export default {
  barfactor: {
    searchPlaceholder: '元素编号/元素名称',
    codingId: '元素编号',
    codingName: '元素名称',
    parameter: '对应参数',
    instruction: '说明',
    remarks: '备注',
    addByName: '创建人员',
    adddate: '创建时间',
    status: '状态',
    updateByName: '更改人员',
    upddate: '更改时间'
  },
  barpara: {
    searchPlaceholder: '请输入机构编号或机构名称查询',
    officeNo: '机构编号',
    officeName: '机构名称',
    barSplit: '条码分隔符',
    status: '状态',
    addByName: '创建人员',
    adddate: '创建时间',
    updateByName: '更改人员',
    upddate: '更改时间',
    officeId: '所属机构'
  },
  rule: {
    searchPlaceholder: '规则编号/规则名称',
    dialogPlaceholder: '要素编号/要素名称',
    barRuleNo: '规则编号',
    barRuleName: '规则名称/说明',
    officeNo: '机构编号',
    officeName: '机构名称',
    status: '状态',
    officeId: '所属机构',
    statusOptions: ['正常', '停用'],
    barTypeOptions: ['', '批次级'],
    barType: '条码类型',
    dialogTitle: '新增条码规则',
    partNo: '段次号',
    partRemarks: '段次备注',
    codeFactor: '编码要素',
    instruction: '要素说明',
    fieldType: '日期格式',
    fieldValue: '栏位值',
    leng: '栏位长度',
    isLotNoPart: '是否批次组成',
    simulation: '模拟值',
    codingId: '基础元素',
    parameter: '对应参数',
    fieldTypeOptions: ['yyyyMMdd', 'yyMMdd', 'yyyyMM', 'yyMM', 'MMddyyyy', 'MMddyy', 'MMdd', 'yyyy', 'yy']
  }
}
